import { GET_SYM_DIA_FROM_SYM_DIA } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface RelatedSymDiaResponse {
    symptoms?: RelatedSymDia[];
    diagnoses?: RelatedSymDia[];
}
export interface RelatedSymDia {
    id: string;
    name: string;
}

export default (
    symIds?: string,
    diaIds?: string,
    gender?: 'M' | 'F' | 'O',
): Promise<RelatedSymDiaResponse> =>
    fetchWithRefresh(GET_SYM_DIA_FROM_SYM_DIA(symIds || '', diaIds || '', gender)).then((res) =>
        res.json(),
    );
